module.exports = __webpack_public_path__ + "static/media/about Rectangle.25e66dfc.png";